class LogSectorRepository {
  constructor(api) {
    this.api = api;
  }
  async getSectorLogByIdSector(FK_SECTOR) {
    const raw = `
      SELECT TIME,OFFSET FROM CROP.LOG_SECTOR
      WHERE FK_SECTOR = ${FK_SECTOR}
      ORDER BY TIME ASC;
    `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    return resp.length ? resp[0]:null;
  }

  async checkIfEmpty(FK_SECTOR) {
    const raw = `SELECT EXISTS (SELECT * FROM CROP.LOG_SECTOR WHERE FK_SECTOR = ${FK_SECTOR}) as isExists;`;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if(resp.length && resp[0].length){
      let result=resp[0][0]
      return 'isExists' in result?result.isExists:0;
    }
    return;
  }

  async save(FK_SECTOR, TIME, OFFSET) {

    const raw = `
      INSERT INTO CROP.LOG_SECTOR(
        FK_SECTOR,
        TIME,
        OFFSET
      )VALUES(
        ${FK_SECTOR},
        '${TIME}',
        ${OFFSET}
      );`


    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    return resp[0];

  }

  async getSectorByTimeAndIdSector(FK_SECTOR, TIME) {
    const raw = `
      SELECT TIME,OFFSET,FK_SECTOR FROM CROP.LOG_SECTOR
      WHERE FK_SECTOR = ${FK_SECTOR} AND TIME = '${TIME}';
    `

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if(resp.length && resp[0].length){
      return resp[0][0];
    }

    return


  }

  async deleteByFkSector(FK_SECTOR) {
    const raw = `
      DELETE FROM CROP.LOG_SECTOR
      WHERE FK_SECTOR = ${FK_SECTOR};
    `

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });


    return resp.length? resp[0]:null;

  }

  async updateByIdSector(FK_SECTOR,OFFSET){
    const raw=`
      UPDATE CROP.LOG_SECTOR
      SET OFFSET = ${OFFSET}
      WHERE FK_SECTOR = ${FK_SECTOR};
    `

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp
  }



}

export {
  LogSectorRepository
};
